import { createSlice } from "@reduxjs/toolkit"

const promptsDetailsSlice = createSlice({
  name: "promptDetails",
  initialState: {
    installAppPrompt: undefined,
  },
  reducers: {
    setInstallPrompt: (state, action) => {
      state.installAppPrompt = action.payload
    },
    clearInstallPrompt: (state, _) => {
      state.installAppPrompt = undefined
    },
  },
})

export const { setInstallPrompt, clearInstallPrompt } =
  promptsDetailsSlice.actions

export default promptsDetailsSlice.reducer
